/*       */

import { gql } from '@apollo/client';

export default gql`
    query loadUserAboutTeams($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON], $countMax: Int) {
        count: count(dataType: "team", filterBy: $filterBy, max: $countMax)
        records: teams(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            id
            name
            modifiedDate
        }
    }
`;
